import RouteFeedbackPage from "./RouteFeedbackPage";

export default RouteFeedbackPage;
